import React, { useState, useEffect } from "react";
import axios from "axios";
import { Spinner } from "reactstrap";
import moment from "moment";
import { Cookies } from "react-cookie";
import "moment/locale/ko";

moment.locale("ko");
const cookies = new Cookies();

function AirScheduleCalendar() {
  const [schedules, setSchedules] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentDate, setCurrentDate] = useState(moment());

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/search/airschedule`,
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        }
      );

      if (response.data.result === "success") {
        setSchedules(response.data.data);
      }
    } catch (error) {
      console.error("스케줄 데이터를 불러오는데 실패했습니다", error);
    } finally {
      setIsLoading(false);
    }
  };

  // 해당 날짜의 스케줄 가져오기
  const getSchedulesForDate = (date) => {
    const dateStr = moment(date).format("YYYY-MM-DD");
    return schedules.filter((schedule) => {
      const scheduleDate = moment(schedule.depature_at).format("YYYY-MM-DD");
      return scheduleDate === dateStr;
    });
  };

  // 달력 렌더링
  const renderCalendar = () => {
    const startOfMonth = currentDate.clone().startOf("month");
    const endOfMonth = currentDate.clone().endOf("month");
    const startDate = startOfMonth.clone().startOf("week");
    const endDate = endOfMonth.clone().endOf("week");

    const days = [];
    let day = startDate.clone();

    while (day.isSameOrBefore(endDate, "day")) {
      days.push(day.clone());
      day.add(1, "day");
    }

    const weekDays = ["일", "월", "화", "수", "목", "금", "토"];

    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() =>
              setCurrentDate(currentDate.clone().subtract(1, "month"))
            }
          >
            이전
          </button>
          <h6 className="mb-0">{currentDate.format("YYYY년 MM월")}</h6>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => setCurrentDate(currentDate.clone().add(1, "month"))}
          >
            다음
          </button>
        </div>

        <table className="table table-bordered" style={{ fontSize: "0.9rem" }}>
          <thead>
            <tr className="table-primary">
              {weekDays.map((day) => (
                <th
                  key={day}
                  className="text-center p-2"
                  style={{ width: "14%" }}
                >
                  {day}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: Math.ceil(days.length / 7) }).map(
              (_, weekIndex) => (
                <tr key={weekIndex}>
                  {days
                    .slice(weekIndex * 7, (weekIndex + 1) * 7)
                    .map((date, dayIndex) => {
                      const dateSchedules = getSchedulesForDate(date);
                      const isCurrentMonth = date.isSame(currentDate, "month");
                      const isToday = date.isSame(moment(), "day");
                      const hasSchedule = dateSchedules.length > 0;

                      return (
                        <td
                          key={dayIndex}
                          className={`text-center p-2 ${
                            !isCurrentMonth ? "text-muted bg-light" : ""
                          } ${
                            isToday ? "border border-primary border-2" : ""
                          } ${
                            hasSchedule && isCurrentMonth
                              ? "bg-warning bg-opacity-25"
                              : ""
                          }`}
                          style={{
                            minHeight: "80px",
                            verticalAlign: "top",
                            backgroundColor:
                              hasSchedule && isCurrentMonth
                                ? "#fff3cd"
                                : undefined,
                          }}
                        >
                          <div>{date.format("D")}</div>
                          {dateSchedules.length > 0 && (
                            <div
                              className="mt-1"
                              style={{ fontSize: "0.75rem" }}
                            >
                              {dateSchedules.map((schedule, idx) => (
                                <div
                                  key={schedule.air_schedule_index || idx}
                                  className="mb-1"
                                >
                                  {schedule.air_schedule_content ||
                                    `${schedule.aoo || "NZAKL"}`}
                                </div>
                              ))}
                            </div>
                          )}
                        </td>
                      );
                    })}
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="border p-3">
      {isLoading ? (
        <div className="text-center p-5">
          <Spinner type="border" />
        </div>
      ) : (
        renderCalendar()
      )}
    </div>
  );
}

export default AirScheduleCalendar;
